<div class="mb-3 position-relative">
  @if (label) {
    <label class="form-label fw-medium"
      >{{ label }} <span *ngIf="isRequired" class="text-danger">*</span></label
    >
  }
  @if (control) {
    <div class="input-group">
      <textarea
        [rows]="rows"
        class="form-control rounded-5 p-3"
        [placeholder]="placeholder"
        [value]="value"
        [disabled]="disabled"
        (input)="handleInput($event)"
        (focus)="handleFocus()"
        (blur)="handleBlur()"
        [formControl]="control"
        [ngClass]="{ 'is-invalid': hasError }"
        [attr.maxlength]="maxlength ? maxlength : null"
        [attr.minlength]="minlength ? minlength : null"
      ></textarea>

      @if (hasError) {
        <div class="invalid-feedback">
          {{ errorMessages }}
        </div>
      }
    </div>
    @if (maxlength && !disabled) {
      <small class="text-muted d-block mt-1 text-end chars-counter">
        {{ remainingChars }} characters (min {{ minlength }})
      </small>
    }
  } @else if (standaloneValue !== undefined) {
    <div class="input-group">
      <textarea
        [rows]="rows"
        class="form-control rounded-5 p-3"
        [placeholder]="placeholder"
        [value]="standaloneValue ?? ''"
        disabled
        readonly
        [attr.maxlength]="maxlength ? maxlength : null"
        [attr.minlength]="minlength ? minlength : null"
      ></textarea>
    </div>
  }
</div>
